import React from "react";
import ReactDOM from "react-dom/client";
import "./styles/index.css";
import RXApp from "./rx_app";
import "../../shared_components/src/shared.css";
import { ProductProvider } from "./components/ProductProvider";
import { FilterProvider } from "@shared_components/providers/FilterProvider";
import { MessageProvider } from "@shared_components/providers/MessageProvider";

let root = ReactDOM.createRoot(document.getElementById("app_rxsite") as HTMLElement);

root.render(
       <ProductProvider >
       <FilterProvider >
              <MessageProvider>
                     <RXApp />
              </MessageProvider>
       </FilterProvider>
       </ProductProvider>
);
